import React from 'react';
import context from "./../../lib/context.js";
import { Modal, FormControl, Alert, Button, ModalFooter, Checkbox } from 'react-bootstrap';
import ajax from "./../../lib/ajax.js";
import { browserHistory } from "react-router";

export default class AccountVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alertText: "",
            showDialog: true,
            showResendText: false,
            peopleEmail: "",
            userPasscode: "",
            rememberMe: false

        }
        this.handleResendCode = this.handleResendCode.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.validateUserCode = this.validateUserCode.bind(this);
        this.newPasswordChange = this.newPasswordChange.bind(this);
    }

    validateUserCode() {
        let code = this.state.userPasscode.trim();
        let remember = this.state.rememberMe? '1': '0';
        let self = this;
        let currentHref = this.props.currentHref;

        if (code.length != 6) {
            self.setState({alertText: 'Please enter a 6-digit code'});
            return false;
        }

        if (isNaN(code)) {
            self.setState({alertText: 'Incorrect or expired code'});
            return false;
        }

        context.message({ show: true, type: "loading", message: "Loading. Please wait..." });
        ajax.api()
            .post(`people/user-face-challenge/${code}/${remember}`)
            .then(function (res) {
                context.message({ show: false });
                const data = res.data;
                self.setState({
                    showDialog: !data.userPassedChallenge,
                    alertText: data.failedReason
                });
                if (data.userPassedChallenge) {
                    browserHistory.push(context.routeUrl(currentHref));
                }
            })
            .catch(function (err) {
                self.setState({
                    showDialog: false,
                });
                let data = err.response.data;
                console.log(data);
                context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
            });

    }
    handleResendCode() {
        context.message({ show: true, type: "loading", message: "Loading. Please wait..." });
        let self = this;
        ajax.api()
            .get("people/user-challenge")
            .then(function (res) {
                const result = res.data;
                self.setState({
                    peopleEmail: result.peopleEmail,
                    showResendText: true,
                    userPasscode: "",
                    alertText: "",
                });
                context.message({ show: false, });
            })
            .catch(function (err) {
                let data = err.response.data;
                console.log(data);
                context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
            });

    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            showDialog: nextProps.showDialog,
            peopleEmail: nextProps.peopleEmail,
        });
    }
    closeDialog() {
        this.setState({
            showDialog: false,
            alertText: "",
            showResendText: false,
            peopleEmail: "",
            userPasscode: "",
            rememberMe: false,
        });
    }
    newPasswordChange(event) {
        let value = event.target.value.trim().substring(0, 6);
        this.setState({
            userPasscode: value,
        });
    }
    render() {
        return (
            <div className="container-fluid">
                <Modal show={this.state.showDialog} onHide={this.closeDialog} backdrop='static'>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Account Verification
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    please enter the 6-digit Verification Code sent to <b>{this.props.peopleEmail}</b>.
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-12">
                                    <b>Note:</b> If your email address is incorrect or you did not receive an email, Please contact HelpDesk
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-4">
                                    <FormControl type="text" value={this.state.userPasscode} onChange={this.newPasswordChange} />
                                </div>
                                <div className="col-md-8 ap-alert-text-height">
                                    {
                                        this.state.alertText ? <Alert bsStyle="danger">{this.state.alertText}</Alert> : null
                                    }
                                </div>
                                <br />
                                <div className="col-md-12">
                                    <a href="#" onClick={this.handleResendCode}>Request a new Verification Code</a>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="container-fluid">
                            <div className={this.state.showResendText ? "row" : "ap-hidden"}>
                                <div className="col-md-12 text-left">
                                    A new verification code was generated and sent to <b>{this.state.peopleEmail}</b>.
                                </div>
                                <br />
                                <br />
                            </div>
                            <div className="row">
                                <div className="col-md-8 text-left col-xs-8">
                                    <Checkbox onChange={(evt) => { this.setState({ rememberMe: evt.target.checked, }); }}>
                                        <span style={{color: "#4d4d4d", fontSize: "14px", fontWeight: "700"}}>
                                            Remember me on this device
                                        </span>
                                    </Checkbox>
                                </div>
                                <div className="col-md-2 text-center col-xs-2">
                                    <Button onClick={this.validateUserCode}>SUBMIT</Button>
                                </div>

                                <div className="col-md-2 text-center col-xs-2">
                                    <Button onClick={this.closeDialog}>CANCEL</Button>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}